import React, { PureComponent } from "react";

import ComponentError from "./ComponentError";

export class ErrorBind extends PureComponent {
  state = { error: null };

  componentDidCatch(error) {
    window.bugsnagClient && typeof window.bugsnagClient.notify === "function" && window.bugsnagClient.notify(error);
    this.setState({ error });
  }

  render() {
    const { item, children } = this.props;
    const { error } = this.state;

    return error ? GLOBALS.ENV === "production" ? null : <ComponentError name={item.name} /> : children;
  }
}
